import OLImageLayer from 'ol/layer/Image'
import OLTileLayer from 'ol/layer/Tile'
import OLVectorLayer from 'ol/layer/Vector'
import OLLayerGroup from 'ol/layer/Group'
import {Source, XYZ, TileWMS, ImageWMS, TileImage, VectorSource} from './Sources'
import ImageSource from 'ol/source/Image'
import TileSource from 'ol/source/Tile'

interface IHack {
  urls: Array<string>
  guid: string
  type: 'basemap' | 'draw' | 'regular' | 'edit'
  refreshOnExtentChange: boolean
  isActive: boolean
}

interface ILayerHack {
  moreInfo: IHack
}
type Base = ImageLayer | TileLayer | VectorLayer
type Layer = ImageLayer | TileLayer | VectorLayer | LayerGroup

class ImageLayer extends OLImageLayer<ImageSource> implements ILayerHack {
  moreInfo: IHack
  getSourceParams(): {[key: string]: any} {
    return (super.getSource() as any).getParams()
  }
  updateSourceParams(params: {[key: string]: any}): void {
    ;(super.getSource() as any).updateParams(params)
  }
  getSource(): ImageSource {
    return super.getSource() as ImageSource
  }
  refresh() {
    ;(this.getSource() as any).updateParams({time: Date.now()})
  }
}

class TileLayer extends OLTileLayer<TileSource> implements ILayerHack {
  moreInfo: IHack
  getSourceParams(): {[key: string]: any} {
    return (super.getSource() as any).getParams()
  }
  updateSourceParams(params: {[key: string]: any}): void {
    ;(super.getSource() as any).updateParams(params)
  }
  getSource(): TileSource {
    return super.getSource() as TileSource
  }
  refresh() {
    this.getSource().changed()
  }
}

class VectorLayer extends OLVectorLayer<any> implements ILayerHack {
  moreInfo: IHack
  getSourceParams(): {[key: string]: any} {
    return (super.getSource() as any).getParams()
  }
  updateSourceParams(params: {[key: string]: any}): void {
    ;(super.getSource() as any).updateParams(params)
  }
  getSource(): VectorSource {
    return super.getSource() as VectorSource
  }
  refresh() {
    const source = this.getSource()
    if (source instanceof VectorSource) {
      source.clear()
    }
  }
}

class LayerGroup extends OLLayerGroup implements ILayerHack {
  moreInfo: IHack
  getLayersBase(): Base[] {
    return super.getLayers().getArray() as Base[]
  }
  refresh() {
    this.getLayersBase().forEach(l => {
      l.refresh()
    })
  }
}

export {ImageLayer, TileLayer, VectorLayer, LayerGroup, Layer, Base}
